// src/pages/NotFoundPage/NotFoundPage.tsx
import React from 'react';
import { Link } from 'react-router-dom';

const NotFoundPage: React.FC = () => {
  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #1a365d 0%, #2563eb 50%, #047857 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: 'white',
      textAlign: 'center',
      padding: '20px'
    }}>
      <div style={{
        background: 'rgba(255, 255, 255, 0.1)',
        backdropFilter: 'blur(10px)',
        borderRadius: '20px',
        padding: '60px 40px',
        maxWidth: '500px'
      }}>
        <div style={{
          fontFamily: '"Noto Naskh Arabic", "Amiri", serif',
          fontSize: '1.5rem',
          marginBottom: '20px',
          opacity: 0.9
        }}>
          بِسْمِ اللهِ الرَّحْمَٰنِ الرَّحِيمِ
        </div>
        
        <div style={{
          fontSize: '6rem',
          fontWeight: '900',
          color: '#fbbf24',
          marginBottom: '20px'
        }}>
          404
        </div>
        
        <h1 style={{ fontSize: '2rem', marginBottom: '10px' }}>
          Page non trouvée
        </h1>
        
        <p style={{ fontSize: '1.1rem', marginBottom: '30px', opacity: 0.9 }}>
          La page que vous recherchez n'existe pas.
        </p>
        
        <Link 
          to="/" 
          style={{
            display: 'inline-block',
            background: 'linear-gradient(135deg, #059669, #10b981)',
            color: 'white',
            padding: '15px 30px',
            borderRadius: '25px',
            textDecoration: 'none',
            fontWeight: '600',
            fontSize: '1rem'
          }}
        >
          🏠 Retour à l'accueil
        </Link>
      </div>
    </div>
  );
};

export default NotFoundPage;